import PeriodCalendar from './PeriodCalendar';
import MonthCalendar from './MonthCalendar';

export const CALENDAR_TYPE = {
  MONTHLY: 'CALENDAR_TYPE_MONTHLY',
  PERIOD: 'CALENDAR_TYPE_PERIOD',
};

function Calendar({ calendarType = CALENDAR_TYPE.MONTHLY, ...props }) {
  if (calendarType === CALENDAR_TYPE.PERIOD) {
    return <PeriodCalendar {...props} />;
  }
  return <MonthCalendar {...props} />;
}

export default Calendar;
